import { computePosition, flip, shift, offset } from '@floating-ui/dom';

export default () => {
    const triggers = document.querySelectorAll('[data-tooltip]');

    triggers.forEach((el) => {
        const tooltip = document.querySelector(el.dataset.tooltip);

        if (!tooltip) {
            return;
        }

        el.addEventListener('mouseover', () => {
            tooltip.show();

            computePosition(el, tooltip, {
                placement: 'bottom',
                middleware: [offset(20), flip(), shift({ padding: 10 })],
            }).then(({ x, y }) => {
                Object.assign(tooltip.style, {
                    left: `${x}px`,
                    top: `${y}px`,
                });
            });
        });

        el.addEventListener('mouseout', () => {
            tooltip.close();
        });
    });
};
